import { render, staticRenderFns } from "./Ribbons.vue?vue&type=template&id=bbdb0762&scoped=true&"
import script from "./Ribbons.vue?vue&type=script&lang=js&"
export * from "./Ribbons.vue?vue&type=script&lang=js&"
import style0 from "./Ribbons.vue?vue&type=style&index=0&id=bbdb0762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdb0762",
  null
  
)

export default component.exports